module.exports = __webpack_public_path__ + "common/icon-singlecolor-8c8b3919b1b3920dee5837dbae5c5e9f.svg";